import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-g-small', 'LetterGSmall', [["path",{"d":"M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1","key":"svg-0"}]]);